import type {ReactNode} from "react";
import {SubmenuItem} from "nav/hoverMenu";
import LanguageRows from "nav/LanguageRows";
import {useLanguageChoices} from "nav/useLanguageChoices";

/**
 * The shared nested "Language ▸" menu item (ui#119): a single parent row (the localized "Language"
 * label + the active locale's flag as a hint + a chevron) that reveals the 🇬🇧 English / 🇷🇴 Română
 * {@link LanguageRows} — as a side flyout on a desktop pointer, or expanded inline on touch/≤640px.
 *
 * It composes the generic {@link SubmenuItem} hover primitive with the shared {@link LanguageRows} and
 * {@link useLanguageChoices}. Since ui#812 the Resources dropdown is its ONE home — both auth states
 * render it there, so the picker never changes address on login (it used to move into the ProfileMenu,
 * ui#117). Picking a locale fires `onSelected` (the host closes both the submenu and its parent menu)
 * and persists `locale-v1`; the active locale keeps its check.
 */
export default function LanguageSubmenuItem({icon, onSelected}: {icon?: ReactNode; onSelected?: () => void}) {
	const {current, label} = useLanguageChoices();
	return (
		<SubmenuItem label={label} icon={icon} hint={current.flag} submenuLabel={label}>
			<LanguageRows onSelected={onSelected}/>
		</SubmenuItem>
	);
}
